import Qs from 'qs';
import type { IQueryParams } from './IQueryParams';

export function stringifyQuery(params: IQueryParams): string {
	return Qs.stringify(params, {
		arrayFormat: 'brackets'
	});
}
